import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { faThumbtack as faThumbtackLight } from '@fortawesome/pro-light-svg-icons';
import './AdminNavMenuItem.scss';

const AdminNavMenuItem = ({ item, isActive, isPinned, onTogglePin }) => (
  <div className={cn('admin-nav-menu-item', { active: isActive })}>
    <a href={item.path} className='item-link'>
      <FontAwesomeIcon icon={item.icon} className='item-icon' fixedWidth />
      <span className='item-text'>
        <span className='item-label'>{item.label}</span>
        <span className='item-description'>{item.description}</span>
      </span>
    </a>
    <button
      className={cn('pin-button', { pinned: isPinned })}
      onClick={() => onTogglePin(item.key)}
      type='button'
      aria-label={isPinned ? `Unpin ${item.label}` : `Pin ${item.label}`}
    >
      <FontAwesomeIcon icon={isPinned ? faThumbtack : faThumbtackLight} />
    </button>
  </div>
);

AdminNavMenuItem.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  isActive: PropTypes.bool,
  isPinned: PropTypes.bool,
  onTogglePin: PropTypes.func.isRequired
};

export default AdminNavMenuItem;
